<template>
  <div class="wrap">
    <div v-for="(item, index) in urlList" :key="index" class="img-upload" :class=" disabled ? 'disabled-wrapper':''">
      <template v-if="item.type === 'image'">
        <img class="img" :src="item[itemKey]" alt="img" />
        <div class="hover">
          <i class="el-icon-zoom-in icon" @click="handleImgClick(index)"></i>
          <i v-if="!disabled" class="el-icon-delete icon del-icon" @click="handleRemove(index)"></i>
        </div>
      </template>
      <template v-if="item.type === 'excel'">
        <img class="img" :src="excelIcon" />
        <div class="hover">
          <i class="el-icon-download icon" @click="handleDownload(item[itemKey])"></i>
          <i v-if="!disabled" class="el-icon-delete icon del-icon" @click="handleRemove(index)"></i>
        </div>
      </template>
      <template v-if="item.type === 'word'">
        <img class="img" :src="wordIcon" />
        <div class="hover">
          <i class="el-icon-download icon" @click="handleDownload(item[itemKey])"></i>
          <i v-if="!disabled" class="el-icon-delete icon del-icon" @click="handleRemove(index)"></i>
        </div>
      </template>
      <template v-if="item.type === 'pdf'">
        <img class="img" :src="pdfIcon" />
        <div class="hover">
          <i class="el-icon-download icon" @click="handleDownload(item[itemKey])"></i>
          <i v-if="!disabled" class="el-icon-delete icon del-icon" @click="handleRemove(index)"></i>
        </div>
      </template>
      <template v-if="item.type === ''">
        <img class="img" :src="errorIcon" />
        <div class="hover">
          <i v-if="!disabled" class="el-icon-delete icon del-icon" @click="handleRemove(index)"></i>
        </div>
      </template>
    </div>
    <div v-if="urlList.length<+limit && !disabled" class="img-upload">
      <input
        ref="input"
        :accept="accept"
        class="input"
        type="file"
        multiple
        @change="handleChange" />
      <i v-if="!uploading" class="el-icon-plus plus-icon"></i>
      <svg v-if="uploading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="60px" height="60px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <path d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50" fill="#e15b64" stroke="none">
          <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 50 51;360 50 51"></animateTransform>
        </path>
      </svg>
    </div>
  </div>
</template>

<script>
import { uploadFile } from 'src/utils/upload'
import ImageFullScreen from '@/widget/Viewer'
const fileType = {
  doc: 'word',
  docx: 'word',
  xls: 'excel',
  xlsx: 'excel',
  png: 'image',
  jpeg: 'image',
  jpg: 'image',
  pdf: 'pdf',
}
export default {
  name: 'SingleUpload',
  props: {
    itemKey: {
      type: String,
      default: 'url',
    },
    value: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    maxSize: {
      type: Number,
      default: 10 * 1024 * 1024,
    },
    limit: {
      type: [String, Number],
      default: 9,
    },
    accept: {
      type: String,
      default: '.pdf,.png,.jpg,.jpeg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
    },
  },
  data () {
    return {
      urlList: [],
      percent: 0,
      uploading: false,
      errorIcon: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/usercenter/wenjcuoIcon.png',
      excelIcon: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/usercenter/excelIcon.png',
      wordIcon: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/usercenter/wordIcon.png',
      pdfIcon: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/usercenter/pdfIcon.svg',
    }
  },
  watch: {
    urlList (newVal, oldVal) {
      this.$emit('input', newVal)
      this.dispatch('ElFormItem', 'el.form.change', [newVal])
    },
    value: {
      handler: function (newVal, oldVal) {
        const a = JSON.stringify(newVal)
        const b = JSON.stringify(oldVal)
        if (a !== b) {
          if (newVal && newVal.length) {
            this.urlList = newVal.map(bar => {
              const type = this.getFileSuffix(bar.url)
              return {
                url: bar.url,
                type: fileType[type] || '',
              }
            })
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    getFileSuffix (name) {
      return name.slice(name.lastIndexOf('.') + 1).toLowerCase()
    },
    // 上传
    async handleChange ({ target }) {
      try {
        if (!target.files.length) return
        if (target.files.length + this.urlList.length > +this.limit) {
          this.$warn(`最多可上传${this.limit}个文件！`)
          return
        }
        const files = Array.from(target.files)
        let sizeFlag = false
        let suffixFlag = false
        files.forEach(item => {
          const suffix = this.getFileSuffix(item.name)
          if (!fileType[suffix]) {
            suffixFlag = true
          }
          if (item.size > this.maxSize) {
            const tips = this.maxSize < 1024 * 1024 ? `${this.maxSize / 1024}K` : `${this.maxSize / 1024 / 1024}M`
            this.$warn(`文件大小不能大于${tips}！`)
            sizeFlag = true
          }
        })
        if (suffixFlag) {
          throw new Error('只允许上传doc、docx、xls、xlsx、png、jpeg、jpg、pdf文件！')
        }
        if (sizeFlag) return
        this.uploading = true
        // 文件处理
        const uploadList = files.map(file => {
          return uploadFile(file)
        })
        // 文件上传
        const res = await Promise.all(uploadList)
        res.forEach(item => {
          const url = item
          const type = this.getFileSuffix(url)
          this.urlList.push({
            url: url,
            type: fileType[type] || '',
          })
        })
      } catch (e) {
        this.$error(e)
      } finally {
        this.$refs.input.value = ''
        this.uploading = false
      }
    },
    // 文件下载
    handleDownload (url) {
      window.open(url)
    },
    // 文件删除
    handleRemove (index) {
      this.urlList.splice(index, 1)
    },
    // 图片查看
    handleImgClick (index) {
      const list = this.urlList.filter(bar => bar.type === 'image')
      let currentIndex = 0
      for (let i = 0; i <= index; i++) {
        if (this.urlList.type === 'image') {
          currentIndex++
        }
      }
      ImageFullScreen({
        list: list,
        itemKey: 'url',
        index: currentIndex,
      })
    },
    dispatch (componentName, eventName, params) {
      var parent = this.$parent || this.$root
      var name = parent.$options.componentName
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent
        if (parent) {
          name = parent.$options.componentName
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params))
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.wrap{
  display: flex;
  flex-wrap: wrap;
}
.img-upload {
  width: 82px;
  height: 82px;
  position: relative;
  border: 1px dashed #c0c4cc;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 10px;
}
.disabled-wrapper {
  border: 1px solid #E5E5E5;
}
.img-upload .img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.img-upload .process {
  padding: 20px;
}
.img-upload .input {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.img-upload .plus-icon {
  font-size: 24px;
  color: #c0c4cc;
}
.img-upload:hover{
  .hover{
    display: flex;
  }
}
.hover{
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: #409eff;
  font-size: 18px;
  background-color: rgba(0,0,0,.6);
  align-items: center;
  justify-content: center;
  .icon{
    cursor: pointer;
  }
  .del-icon{
    margin-left: 5px;
  }
}
</style>
